import React from "react"
import cx from "classnames"
import { useNavigationContext } from "./navigation-context"

// =============================================================================
// Props
// =============================================================================

export type NavigationHeaderCollapsibleContentProps = {
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const navigationHeaderCollapsibleContentStyles = [
  "relative flex items-center gap-1 h-6"
]

// =============================================================================
// Component
// =============================================================================

/**
 * Collapsible content for the navigation header.
 *
 * Only visible when the sidebar is expanded.
 *
 * Compose with `Navigation.LogoLink` and optional children.
 *
 * @example
 * <Navigation.Header>
 *   <Navigation.HeaderCollapsibleContent>
 *     <Navigation.LogoLink href="/dashboard" />
 *   </Navigation.HeaderCollapsibleContent>
 *
 *   <Navigation.Trigger />
 * </Navigation.Header>
 */
export function NavigationHeaderCollapsibleContent({
  children
}: NavigationHeaderCollapsibleContentProps) {
  const { collapsed } = useNavigationContext()

  return (
    <div
      data-slot="navigation-header-collapsible-content"
      className={cx(navigationHeaderCollapsibleContentStyles)}
    >
      {!collapsed && <>{children}</>}
    </div>
  )
}

NavigationHeaderCollapsibleContent.displayName =
  "Navigation.HeaderCollapsibleContent"
